import { gql } from 'apollo-boost';

export const PATCH_PREFERRED_LANGUAGE = gql`
mutation patchPreferredLanguage($input:PreferredLanguageInput!){
    patchPreferredLanguage(input:$input){
      value
    }
}`;